export default __webpack_public_path__ + "static/media/INNOMOTICS-logo-short-lime-gray-RGB-1024px-square.de4c9e46.png";